import axios from 'axios'
import { SequencesUrlBase } from '@/services/config'

const sequencesService = {}

sequencesService.addListToSequence = async function (token, appId, data) {
  try {
    const { listId, sequenceId } = data
    const request = {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token}`
      },
      data: {
        listId
      },
      url: `${SequencesUrlBase}${appId}/sequences/${sequenceId}/users/init/list`
    }
    await axios(request)
  } catch (e) {
    console.log(e.message)
    throw e.message
  }
}

sequencesService.createSequence = async function (token, appId, data) {
  try {
    const { active, name, initSequenceAt, initTimeZone, responsibleId, serviceHoursId } = data
    const request = {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token}`
      },
      data: {
        name,
        active,
        initSequenceAt,
        initTimeZone,
        responsibleId,
        serviceHoursId
      },
      url: `${SequencesUrlBase}${appId}/sequences`
    }
    const response = await axios(request)
    return response.data
  } catch (e) {
    console.log(e.message)
    throw e.message
  }
}

sequencesService.createSequencePerson = async function (token, appId, sequenceId, stepId, data) {
  try {
    const request = {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token}`
      },
      data: {
        sequenceId,
        stepId,
        ...data
      },
      url: `${SequencesUrlBase}${appId}/sequences/${sequenceId}/users`
    }
    await axios(request)
  } catch (e) {
    console.log(e.message)
    throw e.message
  }
}

sequencesService.createSequencesRule = async function (token, appId, data) {
  try {
    const request = {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token}`
      },
      url: `${SequencesUrlBase}${appId}/rules`,
      data
    }
    await axios(request)
  } catch (e) {
    console.log(e.message)
    throw e.message
  }
}

sequencesService.createSequencesSchedule = async function (token, appId, data) {
  try {
    const request = {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token}`
      },
      url: `${SequencesUrlBase}${appId}/service/hours`,
      data
    }
    await axios(request)
  } catch (e) {
    console.log(e.message)
    throw e.message
  }
}

sequencesService.createSequenceStep = async function (token, appId, sequenceId, data) {
  try {
    const request = {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token}`
      },
      url: `${SequencesUrlBase}${appId}/sequences/${sequenceId}/steps`,
      data
    }
    await axios(request)
  } catch (e) {
    console.log(e.message)
    throw e.message
  }
}

sequencesService.deleteSequence = async function (token, appId, sequenceId) {
  try {
    const request = {
      method: 'DELETE',
      headers: {
        Authorization: `Bearer ${token}`
      },
      url: `${SequencesUrlBase}${appId}/sequences/${sequenceId}`
    }
    await axios(request)
  } catch (e) {
    console.log(e.message)
    throw e.message
  }
}

sequencesService.deleteSequenceStep = async function (token, appId, sequenceId, stepId) {
  try {
    const request = {
      method: 'DELETE',
      headers: {
        Authorization: `Bearer ${token}`
      },
      url: `${SequencesUrlBase}${appId}/sequences/${sequenceId}/${stepId}`
    }
    await axios(request)
  } catch (e) {
    console.log(e.message)
    throw e.message
  }
}

sequencesService.deleteUserFromSequence = async function (token, appId, sequenceId, userId) {
  try {
    const request = {
      method: 'DELETE',
      headers: {
        Authorization: `Bearer ${token}`
      },
      url: `${SequencesUrlBase}${appId}/sequences/${sequenceId}/users/${userId}`
    }
    await axios(request)
  } catch (e) {
    console.log(e.message)
    throw e.message
  }
}

sequencesService.getSequence = async function (token, appId, sequenceId) {
  try {
    const request = {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${token}`
      },
      url: `${SequencesUrlBase}${appId}/sequences/${sequenceId}`
    }
    const response = await axios(request)
    return response.data
  } catch (e) {
    console.log(e.message)
    throw e.message
  }
}

sequencesService.getSequencePeople = async function (token, appId, sequenceId, pagination = { page: 1, itemsPerPage: 50 }) {
  const { page, itemsPerPage } = pagination
  try {
    const request = {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${token}`
      },
      params: {
        limit: itemsPerPage,
        page
      },
      url: `${SequencesUrlBase}${appId}/sequences/${sequenceId}/users`
    }
    const response = await axios(request)
    return response.data
  } catch (e) {
    console.log(e.message)
    throw e.message
  }
}

sequencesService.getSequencePerson = async function (token, appId, sequenceId, userId) {
  try {
    const request = {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${token}`
      },
      url: `${SequencesUrlBase}${appId}/sequences/${sequenceId}/users/${userId}`
    }
    const response = await axios(request)
    return response.data
  } catch (e) {
    console.log(e.message)
    throw e.message
  }
}

sequencesService.getSequences = async function (
  token,
  appId,
  pagination = { itemsPerPage: 50, page: 1 }
) {
  const { itemsPerPage, page } = pagination
  try {
    const request = {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${token}`
      },
      params: {
        limit: itemsPerPage,
        page
      },
      url: `${SequencesUrlBase}${appId}/sequences`
    }
    const response = await axios(request)
    return response.data
  } catch (e) {
    console.log(e.message)
    throw new Error(e)
  }
}

sequencesService.getSequencesRule = async function (token, appId, ruleId) {
  try {
    const request = {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${token}`
      },
      url: `${SequencesUrlBase}${appId}/rules/${ruleId}`
    }
    const response = await axios(request)
    return response.data
  } catch (e) {
    console.log(e.message)
    throw e.message
  }
}

sequencesService.getSequencesSchedule = async function (token, appId, scheduleId) {
  try {
    const request = {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${token}`
      },
      url: `${SequencesUrlBase}${appId}/service/hours/${scheduleId}`
    }
    const response = await axios(request)
    return response.data
  } catch (e) {
    console.log(e.message)
    throw e.message
  }
}

sequencesService.getSequencesRules = async function (token, appId) {
  try {
    const request = {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${token}`
      },
      url: `${SequencesUrlBase}${appId}/rules`
    }
    const response = await axios(request)
    return response.data
  } catch (e) {
    console.log(e.message)
    throw e.message
  }
}

sequencesService.getSequencesSchedules = async function (
  token,
  appId,
  pagination = { itemsPerPage: 50, page: 1 }
) {
  const { itemsPerPage, page } = pagination
  try {
    const request = {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${token}`
      },
      params: {
        limit: itemsPerPage,
        page
      },
      url: `${SequencesUrlBase}${appId}/service/hours`
    }
    const response = await axios(request)
    return response.data
  } catch (e) {
    console.log(e.message)
    throw e.message
  }
}

sequencesService.getSequenceStep = async function (token, appId, sequenceId, stepId) {
  try {
    const request = {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${token}`
      },
      url: `${SequencesUrlBase}${appId}/sequences/${sequenceId}/steps/${stepId}`
    }
    const response = await axios(request)
    return response.data
  } catch (e) {
    console.log(e.message)
    throw e.message
  }
}

sequencesService.getSequenceSteps = async function (token, appId, sequenceId) {
  try {
    const request = {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${token}`
      },
      url: `${SequencesUrlBase}${appId}/sequences/${sequenceId}/steps`
    }
    const response = await axios(request)
    return response.data
  } catch (e) {
    console.log(e.message)
    throw e.message
  }
}

sequencesService.runSequence = async function (token, appId, sequenceId) {
  try {
    const request = {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token}`
      },
      url: `${SequencesUrlBase}${appId}/sequences/${sequenceId}/init`
    }
    await axios(request)
  } catch (e) {
    console.log(e.message)
    throw e.message
  }
}

sequencesService.stopSequence = async function (token, appId, sequenceId) {
  try {
    const request = {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token}`
      },
      url: `${SequencesUrlBase}${appId}/sequences/${sequenceId}/stop`
    }
    await axios(request)
  } catch (e) {
    console.log(e.message)
    throw e.message
  }
}

sequencesService.updateSequence = async function (token, appId, sequenceId, data) {
  try {
    const { name, active, initSequenceAt, initTimeZone, responsibleId, serviceHoursId } = data
    const request = {
      method: 'PATCH',
      headers: {
        Authorization: `Bearer ${token}`
      },
      data: {
        name,
        active,
        initSequenceAt,
        initTimeZone,
        responsibleId,
        serviceHoursId
      },
      url: `${SequencesUrlBase}${appId}/sequences/${sequenceId}`
    }
    await axios(request)
  } catch (e) {
    console.log(e.message)
    throw e.message
  }
}

sequencesService.updateSequencePerson = async function (token, appId, data) {
  try {
    const { name, email, phone, sequenceId, stepId, userId } = data
    const request = {
      method: 'PUT',
      headers: {
        Authorization: `Bearer ${token}`
      },
      data: {
        name,
        email,
        phone,
        sequenceId,
        stepId,
        userId
      },
      url: `${SequencesUrlBase}${appId}/sequences/${sequenceId}/users/${userId}`
    }
    await axios(request)
  } catch (e) {
    console.log(e.message)
    throw e.message
  }
}

sequencesService.updateSequencesRule = async function (token, appId, ruleId, data) {
  try {
    const request = {
      method: 'PATCH',
      headers: {
        Authorization: `Bearer ${token}`
      },
      data,
      url: `${SequencesUrlBase}${appId}/rules/${ruleId}`
    }
    await axios(request)
  } catch (e) {
    console.log(e.message)
    throw e.message
  }
}

sequencesService.updateSequencesSchedule = async function (token, appId, scheduleId, data) {
  const { name, observation, dayAndHours } = data
  try {
    const request = {
      method: 'PATCH',
      headers: {
        Authorization: `Bearer ${token}`
      },
      data: {
        name,
        observation,
        dayAndHours
      },
      url: `${SequencesUrlBase}${appId}/service/hours/${scheduleId}`
    }
    await axios(request)
  } catch (e) {
    console.log(e.message)
    throw e.message
  }
}

sequencesService.updateSequenceStep = async function (token, appId, sequenceId, stepId, data) {
  try {
    const request = {
      method: 'PATCH',
      headers: {
        Authorization: `Bearer ${token}`
      },
      data,
      url: `${SequencesUrlBase}${appId}/sequences/${sequenceId}/steps/${stepId}`
    }
    await axios(request)
  } catch (e) {
    console.log(e.message)
    throw e.message
  }
}

export default sequencesService
